import { Preferences } from '@capacitor/preferences';
import { isNative } from '@/domains/shared/utils/native';

export const TRUSTED_DEVICE_TOKEN_KEY = 'trustedDeviceToken';

export const getTrustedDeviceToken = async (): Promise<string | undefined> => {
  try {
    if (isNative()) {
      const { value } = await Preferences.get({
        key: TRUSTED_DEVICE_TOKEN_KEY,
      });
      return value ?? undefined;
    }
    return localStorage.getItem(TRUSTED_DEVICE_TOKEN_KEY) ?? undefined;
  } catch {
    return undefined;
  }
};

export const setTrustedDeviceToken = async (token: string): Promise<void> => {
  try {
    if (isNative()) {
      await Preferences.set({ key: TRUSTED_DEVICE_TOKEN_KEY, value: token });
      return;
    }
    localStorage.setItem(TRUSTED_DEVICE_TOKEN_KEY, token);
  } catch {}
};
